import React from 'react';
import './about.css';
import ketak from '../../assets/ketak.png';
import tcs from '../../assets/tcs.png'
import { educationData } from '../../Data/educationData';

function About() {
  return (
    <div className='about slide-in-top-animation'>
      <div className="about-container">
        <div className="top-bg">
          <section className="about-heading">
            <h1>Empowering progress:<br/>  Crafting Success Stories</h1>
            <hr />
          </section>
          <section className="about-f">
            <div className="about-f-inside-text">
            I recently joined TCS as a Systems Engineer in Bhubaneswar, starting my career as a fresher. I'm excited to embark on this journey and look forward to how TCS will help me enhance my abilities.
            </div>
            <div className="about-f-inside">
              <img src={tcs} alt="" />
            </div>
          </section>
          <section className="about-ff">
            <div className="about-f-inside-text">
            During my enriching 4-month internship at Ketak Communications, I took on the role of a web developer. I successfully crafted the company's website from conception to completion, ensuring seamless responsiveness across various devices. Additionally, I actively contributed to the "Vastrakari" project, showcasing my versatility and dedication in delivering impactful digital solutions.
            </div>
            <div className="about-f-inside">
              <img src={ketak} alt="" />
            </div>
          </section>
        </div>
        <section className="indiv">
          <section className="about-learning">
            <h1>Learnings<span className='animate-dot'>.</span><span className='animate-dot'>.</span><span className='animate-dot'>.</span></h1>
            <div className="about-learning-container">
              <div className="learning-card">
                  <h4>01</h4>
                  <hr />
                  <h3>Technical skills</h3>
                  <p>Proficient in C++ with basic knowledge of JavaScript, Python, PHP, and SQL. Skilled in web development using React, HTML, and CSS.</p>
              </div>
              <div className="learning-card">
                  <h4>02</h4>
                  <hr />
                  <h3>UIUX</h3>
                  <p>Google UIUX professional certificate. Skills: FIGMA, Adobe XD, UX research, design thinking, UI/UX principles, prototyping, usability testing, cross-functional collaboration.</p>
              </div><div className="learning-card">
                  <h4>03</h4>
                  <hr />
                  <h3>Sketching</h3>
                  <p>I love sketching and watercolor painting in my free time. It helps me unwind and gives me a creative outlet.</p>
              </div>
            </div>
          </section>
        </section>
        <section className="about-education">
          <div className="about-education-container">
            <h1>Education<span className='animate-dot'>.</span><span className='animate-dot'>.</span><span className='animate-dot'>.</span></h1>
            <div className="education-timeline">
              {educationData.map((edu, index) => (
                <div className="education-item" key={edu.degree}>
                  <div className="education-marker-wrap">
                    <div className="education-marker">{String(index + 1).padStart(2, '0')}</div>
                    {index !== educationData.length - 1 && <div className="education-line" />}
                  </div>
                  <div className="education-content">
                    <div className="education-content-top">
                      <h3>{edu.degree}</h3>
                      <span className="education-score">{edu.score}</span>
                    </div>
                    <p className="education-institute">{edu.institute}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default About